import { render, staticRenderFns } from "./Generic.vue?vue&type=template&id=2d894a7a&scoped=true&"
import script from "./Generic.vue?vue&type=script&lang=js&"
export * from "./Generic.vue?vue&type=script&lang=js&"
import style0 from "./Generic.vue?vue&type=style&index=0&id=2d894a7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d894a7a",
  null
  
)

export default component.exports